import React, { useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { useHistory } from "react-router";
import data_tab_data from "../../assets/mockedData/data_tab_data";

const Data = () => {
  const [dataTabData, setDataTabData] = useState(data_tab_data);
  const history = useHistory();
  history.push("/data/datasets");

  return <LoadingSpinner />;
};

export default Data;
